// Framework colours used across the app (same as FrameworkSelector).
export const FW_BG = { EDU: "#ffebee", GOV: "#e8f5e9", TEC: "#e3f2fd", EID: "#fff8e1" };
export const FW_FG = { EDU: "#c62828", GOV: "#2e7d32", TEC: "#1565c0", EID: "#8d6e00" };
export const FW_NAME = { EDU: "Education", GOV: "Governance", TEC: "Technical", EID: "Ethics & Inclusion" };
